module.exports = __webpack_public_path__ + "static/media/kolposkop.06df416e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/kolposkop.jpg
// module id = 422
// module chunks = 0